declare const __NURAMEND_BUILD_ID__: string;

type BuildMeta = { buildId?: string; version?: string; builtAt?: string };

const CLIENT_BUILD_ID = __NURAMEND_BUILD_ID__;
const RELOAD_TARGET_KEY = 'nuramend-build-reload-target';
let reloadStarted = false;

async function clearCacheStorage(): Promise<void> {
  if (!('caches' in window)) return;
  try {
    const keys = await window.caches.keys();
    await Promise.all(keys.map((key) => window.caches.delete(key)));
  } catch {
    // Cache Storage may be unavailable in hardened/private browser contexts.
  }
}

async function checkForNewBuild(): Promise<void> {
  if (reloadStarted) return;
  try {
    const response = await fetch(`/build-meta.json?ts=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { 'cache-control': 'no-cache' },
    });
    if (!response.ok) return;
    const meta = await response.json() as BuildMeta;
    if (!meta.buildId) return;

    if (meta.buildId === CLIENT_BUILD_ID) {
      sessionStorage.removeItem(RELOAD_TARGET_KEY);
      return;
    }

    // Prevent a reload loop if an upstream proxy is incorrectly serving an old
    // HTML document while the new build marker is already live. One hard reload
    // is enough; the no-store server headers then make the mismatch diagnosable.
    if (sessionStorage.getItem(RELOAD_TARGET_KEY) === meta.buildId) return;
    sessionStorage.setItem(RELOAD_TARGET_KEY, meta.buildId);
    reloadStarted = true;
    await clearCacheStorage();

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('_nm_build', meta.buildId.slice(-16));
    window.location.replace(nextUrl.toString());
  } catch {
    // Freshness checks are best-effort and must never block the application.
  }
}

export function startBuildFreshnessMonitor(): void {
  void checkForNewBuild();
  window.setInterval(() => void checkForNewBuild(), 60_000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void checkForNewBuild();
  });
}
